module.exports = __webpack_public_path__ + "40e661fb022ec5f075cd9298314c468a.pdf";